export const avatarSizesAndCoefficients = {
  borderRadiusCoefficients: {
    square: 0,
    // Entity
    roundedCornersLow: 0.25,
    // Activity feed
    roundedCornersMedium: 0.35,
    // Apps and others
    roundedCornersHigh: 0.4,
    // Users
    circle: 0.5,
  },
  iconSizeCoefficient: 0.625,
  avatarSizes: {
    tiny: 24,
    small: 32,
    medium: 40,
    large: 48,
    giant: 56,
    extraGiant: 124,
  },
};
